"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Navigation_1 = __importStar(require("Common/Navigation/Navigation"));
var OpenBrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/OpenBrandSetup"));
var AttachDefaultNavigationButtons_1 = require("./DefaultNavigationButtons/AttachDefaultNavigationButtons");
var ViewOnlyBanner_1 = require("ProjectView/ViewOnlyBanner");
var LockedPageBanner_1 = require("ProjectView/LockedPageBanner");
var inversify_1 = require("inversify");
var TemplatesApiService_1 = require("Dashboard/TemplateManagementDashboard/TemplatesApiService");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var ProjectAppNavigationMount = (function () {
    function ProjectAppNavigationMount(di, mountReactComponent, projectStore, projectViewStore, activeUserStore, pageQuoteTotalStore, projectAuditInspector) {
        this.pageQuoteTotalStore = pageQuoteTotalStore;
        var user = di.get("user");
        var $state = di.get("$state");
        var openBrandSetup = di.invoke(OpenBrandSetup_1.default);
        var publicApiBaseUrl = di.get("publicApiBaseUrl");
        var telemetry = di.get("telemetry");
        var rolesService = di.get("rolesService");
        var onLogoClicked = function (newTab) {
            var newLocation = projectStore.isTemplate && rolesService.isAdmin(user)
                ? $state.href("dashboard", { nav: "templates" })
                : $state.href("dashboard", { nav: "pages" });
            newTab ? window.open(newLocation) : (window.location.href = newLocation);
        };
        var getLogoTooltip = function () {
            return projectStore.isTemplate && rolesService.isAdmin(user)
                ? "Back to templates dashboard"
                : "Back to pages dashboard";
        };
        this.ui = mountReactComponent(react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container();
                container.bind(TemplatesApiService_1.TemplatesApiService).toSelf().inSingletonScope();
                return container;
            } },
            react_1.default.createElement(Navigation_1.default, { pageName: Navigation_1.PageName.Project, user: user, "$state": $state, openBrandSetup: openBrandSetup, publicApiBaseUrl: publicApiBaseUrl, telemetry: telemetry, rolesService: rolesService, showSettings: false, onLogoClick: onLogoClicked, getLogoTooltip: getLogoTooltip }, (0, AttachDefaultNavigationButtons_1.attachDefaultNavigationButtons)(di, projectStore, projectViewStore, activeUserStore, this.pageQuoteTotalStore)),
            getBanner(projectStore, projectAuditInspector)));
    }
    return ProjectAppNavigationMount;
}());
exports.default = ProjectAppNavigationMount;
var getBanner = function (projectStore, projectAuditInspector) {
    var status = projectStore.status;
    if ((0, Types_1.isPageLocked)(status)) {
        var isAccepted = status === Types_1.ProjectStatus.Accepted;
        return (react_1.default.createElement(LockedPageBanner_1.LockedPageBanner, { status: status, auditTrail: isAccepted, auditTrailHandler: isAccepted ? function () { return projectAuditInspector.inspect(projectStore); } : undefined }));
    }
    if (!projectStore.isEditable) {
        return react_1.default.createElement(ViewOnlyBanner_1.ViewOnlyBanner, null);
    }
    return null;
};
